export var AssignmentPassword;

(function (AssignmentPassword) {
  AssignmentPassword["NONE"] = "none";
})(AssignmentPassword || (AssignmentPassword = {}));